module.exports = __webpack_public_path__ + "img/TS.8bd65955.png";